// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"825239bf","163":"f519892e","449":"d8ff83c5","651":"a23d2f95","719":"23b81815","821":"fc3234eb"}[chunkId] + ".css";
};